import "liquid-ajax-cart";
import { qsa, qs, add } from "@fluorescent/dom";
import { section } from "@/js/glow";

section('my-ajax-cart', {
  onLoad() {

    /**
     * AJAX CART **/

    const applyCoupon = () => {
      return new Promise((resolve, reject) => {
        const form = document.getElementById('my-ajax-cart-form-cupon');
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        if (data.discount === undefined || data.discount === '') {
          reject('No se proporcionó un cupón válido.');
        }
        // no permite agregar otro cupon si ya hay aplicado uno
        const url = data.discount.includes(',') ? `${Shopify.routes.root}checkout?discount=${data.discount}&_=${Date.now()}&skip_shop_pay=true` : `/discount/${data.discount}`;
        fetch(url, {method: 'GET'})
          .then(response => response.text())
          .then(done => {
            window.liquidAjaxCart.update({}, {
              lastCallback: () => {
                if (ifActiveGamification() === true) {
                  updateGamification();
                  resolve();
                } else {
                  resolve();
                }
              }
            });
          })
          .catch(error => {
              console.error('Error:', error);
              reject(error);
          });
      });
    };

    const openAjaxCart = (event) => {
      event?.preventDefault();
      document.body.classList.toggle('js-show-ajax-cart');
      document.body.classList.toggle('overflow-hidden');
    };
    
    const updatedProducts = new Set();

    const onChangeAjaxCart = (event) => {
      /*if (ifActiveGamification() === false) {
        return false;
      }*/

      const { requestState } = event.detail;
      const btnToggleCart = document.querySelectorAll('[data-ajax-cart-icon=""]');
      btnToggleCart.forEach(btn => btn.removeEventListener('click', openAjaxCart));
      btnToggleCart.forEach(btn => btn.addEventListener('click', openAjaxCart));
      const rewardPoints = document.querySelector('.my-cart__sidebar .loyalty-point-value');

      //console.log("[>]", requestState);
      //console.log("/", onChangeAjaxCart.name, btnToggleCart);

      if (requestState.responseData?.ok) {
        loadUpsell();
        fixExpressButtons();
        // If the reward points block is displayed, refresh it
        if (rewardPoints) {
          window.loyaltylion.ui.refresh();
        }
      }

      if (requestState.requestType === 'add' && !document.body.classList.contains('js-show-ajax-cart')) {
        document.body.classList.add('js-show-ajax-cart');
        document.body.classList.add('overflow-hidden');
      }

      if ((requestState.requestType === 'add' || requestState.requestType === 'change' || requestState.requestType === 'update') && requestState.responseData?.ok) {
        if (ifActiveGamification() == true) {
          updateGamification();
        } else {
          removeGamification();
        }
      }

      if ((requestState.requestType === 'change' || requestState.requestType === 'update') && requestState.responseData?.ok) {
        if (requestState.responseData.body.items_removed && requestState.responseData.body.items_removed.length > 0) {
          setTimeout(() => {
            const jsonSetting = getCartSettings();
            const removed = requestState.responseData.body.items_removed[0];
            const match = jsonSetting.filter(item => item.id == removed.variant_id);

            if (match.length > 0 && !updatedProducts.has(removed.variant_id)) {
              addRemovedGift(removed.variant_id);
              updatedProducts.add(removed.variant_id); // Marcar como actualizado
            }
          }, 800);
        }
      }
    };

    /**
     * GAMIFITION **/
    
    const updateGamification = () => {
      if (ifActiveGamification() == false) return false;
      
      const goals = document.querySelectorAll('.goal');
      const bars = document.querySelectorAll('.bar');
      const nextGoalDifference = document.getElementById('next-goal-difference');
      const nextGoalName = document.getElementById('next-goal-name');
      const goalMessage = document.getElementById('goal-achieved-message');
      const total = document.getElementById('my-ajax-gamification-total');
      const summary = document.querySelector('.progress-summary');
    
      if (!total) return false;
      //if (window.loadTestCartVariant == false) return false;
    
      const currentTotal = parseFloat(total.value); // Total del carrito.
      let totalGoal = parseFloat(goals[goals.length - 1]?.dataset.goal || 0); // Última meta como límite máximo.
      let lastUnlockedIndex = -1;
      let unlockedRewards = [], // Lista de recompensas desbloqueadas
        addRewards = [], // Lista de recompensas a agregar
        removeRewards = []; // Lista de recompensas a remover
    
      // Iterar sobre las metas (goals) para actualizar su estado
      goals.forEach((goal, index) => {
        const goalAmount = parseFloat(goal.dataset.goal);
        const rewardType = goal.dataset.type;
        const rewardValue = goal.dataset.value;
        const goalName = goal.querySelector('.goal-label').innerText;
    
        if (currentTotal >= goalAmount) {
          goal.classList.add('goal-unlocked');
          goal.style.backgroundColor = '#0F4FAC';
          goal.style.color = '#ffffff';
    
          lastUnlockedIndex = index;
          let goalNameP = rewardType === 'product' ? `a ${goalName}` : goalName;
          unlockedRewards.push(goalNameP); // Agregar la recompensa desbloqueada
          
          const reward = {
            type: rewardType,
            value: rewardValue
          };
          addRewards.push(reward);
        } else {
          goal.classList.remove('goal-unlocked');
          goal.style.backgroundColor = 'white';
          goal.style.color = '#575B5F';
    
          const reward = {
            type: rewardType,
            value: rewardValue
          };
          removeRewards.push(reward);
        }
      });
      updateRewards(addRewards, removeRewards).then(response => {
        //console.log('===>> Response', response);
      }).catch(error => {
        console.error('===>> Error:', error);
      });
    
      // Actualizar el mensaje de logros
      if (goalMessage) {
        if (unlockedRewards.length === 0) {
          goalMessage.classList.add('hidden'); // Ocultar si no hay metas alcanzadas
        } else if (unlockedRewards.length === goals.length) {
          goalMessage.innerText = "CONGRATS! YOU’VE UNLOCKED ALL GIFTS";
          goalMessage.classList.remove('hidden');
        } else {
          const message = `YOU’VE UNLOCKED ${unlockedRewards.join(' + ')}`;
          goalMessage.innerText = message;
          goalMessage.classList.remove('hidden');
        }
      }
    
      // Actualizar las barras
      bars.forEach((bar, index) => {
        const startGoal = index === 0 ? 0 : parseFloat(goals[index - 1]?.dataset.goal || 0);
        const endGoal = parseFloat(goals[index]?.dataset.goal || totalGoal);
    
        if (currentTotal >= endGoal) {
          bar.style.background = '#0F4FAC'; // Barra completamente llena
        } else if (currentTotal > startGoal) {
          const percentage = ((currentTotal - startGoal) / (endGoal - startGoal)) * 100;
          bar.style.background = `linear-gradient(to right, #0F4FAC ${percentage}%, #ffffff ${percentage}%)`;
        } else {
          bar.style.background = 'white';
        }
      });
    
      // Caso especial: barra antes de la primera meta
      if (bars.length > 0 && currentTotal <= parseFloat(goals[0].dataset.goal)) {
        const firstGoal = parseFloat(goals[0].dataset.goal);
        const percentage = (currentTotal / firstGoal) * 100;
        bars[0].style.background = `linear-gradient(to right, #0F4FAC ${percentage}%, #ffffff ${percentage}%)`;
      }
    
      // Actualizar el texto de la siguiente meta
      const nextGoal = goals[lastUnlockedIndex + 1];
      if (nextGoal) {
        const goalAmount = parseFloat(nextGoal.dataset.goal);
        const goalName = nextGoal.querySelector('.goal-label').innerText;
        const goalType = nextGoal.querySelector('.goal-label').dataset.type;
        const goalNameP = goalType === 'product' ? `a ${goalName}` : goalName;
        nextGoalDifference.innerText = `$${(goalAmount - currentTotal).toFixed(2)}`;
        nextGoalName.innerText = goalNameP;
        summary.style.display = 'block';
      } else {
        nextGoalDifference.innerText = '0';
        nextGoalName.innerText = 'any more rewards';
        summary.style.display = 'none';
      }
    };

    const removeGamification = () => {
      if (ifActiveGamification() == true) return false;
      
      const goals = document.querySelectorAll('.goal');
      const total = document.getElementById('my-ajax-gamification-total');
    
      if (!total) return false;
    
      const currentTotal = parseFloat(total.value); // Total del carrito.
      let removeRewards = []; // Lista de recompensas a remover
    
      // Iterar sobre las metas (goals) para actualizar su estado
      goals.forEach((goal, index) => {
        const goalAmount = parseFloat(goal.dataset.goal);
        const rewardType = goal.dataset.type;
        const rewardValue = goal.dataset.value;
    
        if (currentTotal >= goalAmount) {
          const reward = {
            type: rewardType,
            value: rewardValue
          };
          removeRewards.push(reward);
        }
      });
      deleteRewards(removeRewards).then(response => {
        //console.log('===>> Response', response);
      }).catch(error => {
        console.error('===>> Error:', error);
      });
    };

    /**
     * PDP **/

    const pdpRechargeWidget = () => {
      const isPdp = document.querySelector('.template-product ajax-cart-product-form');
      if (!isPdp) return false;
      const radios = document.querySelectorAll('.rc-label-wrapper');
            
      const callback = function (e) {
        const form = isPdp.querySelector('form');
        if (!form) return false;
        const isSelling = form.querySelector('[name="selling_plan"]');
        if (isSelling) {
          isSelling.value = e.target.value;
        } else {
          const input = document.createElement('input');
          input.setAttribute('name', 'selling_plan');
          input.setAttribute('value', e.target.value);
          input.setAttribute('type', 'hidden');
          form.appendChild(input);
        }
      }

      if (radios.length > 0) {
        radios.forEach(r => {
          const label = r.querySelector('.rc-radio');
          label.addEventListener('click', (e) => {
            const item = e.target.closest('.rc-radio');
            const forId = item.getAttribute('for');
            
            setTimeout(() => {
              const form = isPdp.querySelector('form');
              const isSelling = form.querySelector('[name="selling_plan"]');
              const input = document.createElement('input');

              if (forId == "rc-radio1") {
                const select_selling = item.parentElement.querySelector('.js-recharge-select');
                //console.log("[_>]", select_selling);

                if (select_selling) {
                  
                  if (isSelling) {
                    isSelling.value = select_selling.value;
                  } else {
                    input.setAttribute('name', 'selling_plan');
                    input.setAttribute('value', select_selling.value);
                    input.setAttribute('type', 'hidden');
                    form.appendChild(input);
                  }

                  select_selling.removeEventListener('change', callback);
                  select_selling.addEventListener('change', callback);
                }
              } else {
                if (isSelling) {
                  isSelling.value = "";
                } else {
                  input.setAttribute('name', 'selling_plan');
                  input.setAttribute('value', "");
                  input.setAttribute('type', 'hidden');
                  form.appendChild(input);
                }
                //console.log(pdpRechargeWidget.name, ": ", forId);
              }
            }, 500);
          });
        });
      }
    };

    /**
     * REWARDS **/

    const addRewardProducts = (productsAdd) => {
      return new Promise((resolve, reject) => {
        let items = [];
        productsAdd.forEach((id) => {
          if (isRemoveGift(id)) {
            //console.log("Producto eliminado manualmente, no se agregará nuevamente:", id);
            return false;
          } else if (isProductInCart(id)) {
            //console.log("Producto ya está en el carrito:", id);
          } else {
            items.push({
              id: id,
              quantity: 1,
              properties: {
                "_ajax_cart_reward": true,
              },
            });
          }
        });

        if (items.length > 0) {
          window.liquidAjaxCart.add({
            items: items,
          }, {
            lastCallback: () => {
              resolve('Productos agregados correctamente.');
            }
          });
        } else {
          resolve('No hay productos para agregar.');
        }
      });
    };
    
    const removeRewardProducts = (productsRemove) => {
      return new Promise((resolve, reject) => {
        let updates = {};
        productsRemove.forEach((id) => {
          const productExists = window.liquidAjaxCart.cart.items.filter((item) => {
            return item.variant_id === parseInt(id);
          });

          if (productExists && productExists.length > 0) {
            clearRemovedGift(id);
            updates[id] = 0;
          }
        });

        if (updates.length > 0) {
          window.liquidAjaxCart.update({
            updates: updates,
          }, { lastCallback: () => {
            resolve('Productos eliminados correctamente.');
          }});
        } else {
          resolve('No hay productos para eliminar.');
        }
      });
    };
    
    const removeRewardProduct = (idItem, manual = false) => {
      return new Promise((resolve, reject) => {
        const productExists = window.liquidAjaxCart.cart.items.filter((item) => {
          return item.variant_id === parseInt(idItem);
        });
      
        if (productExists && productExists.length > 0) {
          const prod = productExists[0];
          const { key } = prod;
      
          // Marcar eliminación si es manual
          if (manual) {
            addRemovedGift(idItem, true); // Marcar como eliminado manualmente
          } else {
            //setTimeout(() => {
              clearRemovedGift(idItem);
            //}, 500); // Limpiar si es automático
          }
      
          // Eliminar el producto del carrito
          window.liquidAjaxCart.change({
            id: key,
            quantity: 0,
          }, { lastCallback: () => {
            resolve('Producto eliminado correctamente.');
          }});
        } else {
          resolve('El producto no existe en el carrito.');
        }
      });
    };
    
    const getRemovedGift = () => {
      const key = "removeGiftProducts";
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : {};
    };
    
    const addRemovedGift = (id, manual = false) => {
      const key = "removeGiftProducts";
      const removed = getRemovedGift();
      const element = removed[id];
      
      if ( element ) {
        if (element.manual == false && manual == false) {
          removed[id] = { manual }; // Actualiza el flag manual
          sessionStorage.setItem(key, JSON.stringify(removed));
          return false;
        } else if (element.manual == false && manual == true) {
          removed[id] = { manual }; // Actualiza el flag manual
          sessionStorage.setItem(key, JSON.stringify(removed));
          return false;
        } else if ( element.manual == true && manual == false) {
          return false;
        }
      } else {
        removed[id] = { manual }; // Actualiza el flag manual
        sessionStorage.setItem(key, JSON.stringify(removed));
        return false;        
      }
      return false;
    };
    
    const isRemoveGift = (id) => {
      const removed = getRemovedGift();
      return removed[id]?.manual || false; // Solo devolver true si fue eliminado manualmente
    };
    
    const clearRemovedGift = (id) => {
      const key = "removeGiftProducts";
      const removed = getRemovedGift();
    
      if (removed[id]) {
        delete removed[id];
        //console.log("removed: ", removed);
        sessionStorage.setItem(key, JSON.stringify(removed));
        //console.log(`Producto ${id} eliminado del registro de regalos eliminados`);
        return false;
      }
    };

    const updateRewards = (addRewards, removeRewards) => {
      return new Promise((resolve, reject) => {
        // Primero quitamos los rewards que no se deben agregar
        let couponsRemove = [], productsRemove = [];
        // concadenamos todos los cupones y productos que se deben remover
        removeRewards.forEach((reward) => {
          const { type, value } = reward;
          switch (type) {
            case 'coupon':
              // Verificar si el cupón ya está aplicado
              let isCouponApplied = validApplyedCoupon(value)
              isCouponApplied === true && couponsRemove.push(value);
              break;
            case 'product':
              productsRemove.push(value);
              appliedRewards.product.delete(value); // Eliminar el producto del registro
              break;
          }
        });
        if (Object.keys(couponsRemove).length > 0) {
          // si hay al menos cupon a remover se elimina los cupones en total y terminamos el proceso
          updateDiscountField('CLEAR').then(response => {
            resolve(response);
          }).catch((error) => {
            console.error('Error:', error);
            reject(error);
          });
        } else if (Object.keys(productsRemove).length > 0) {
          removeRewardProducts(productsRemove).then(response => {
            resolve(response);
          }).catch((error) => {
            console.error('Error:', error);
            reject(error);
          });
        } else {
          // si no hay cupones a remover se agrega los cupones en total
          let couponsAdd = [], couponsAddLast = [], couponsApplied = [], productsAdd = [];
          // concadenamos los cupones y productos que se deben agregar
          addRewards.forEach((reward) => {
            const { type, value } = reward;
            switch (type) {
              case 'coupon':
                // Verificar si el cupón ya está aplicado
                let isCouponApplied = validApplyedCoupon(value);
                couponsApplied.push(value);
                if (isCouponApplied === true) {
                  if (Object.keys(couponsAdd).length === 0) {
                    couponsAddLast.push(value);
                  } else {
                    couponsAdd.push(value);
                  }
                } else {
                  if (Object.keys(couponsAddLast).length > 0) {
                    couponsAddLast.forEach(val => {
                      couponsAdd.push(val);
                    });
                    couponsAddLast = [];
                  }
                  couponsAdd.push(value);
                }
                break;
              case 'product':
                // Verificar si el producto ya está aplicado o si ya está en el carrito
                if (appliedRewards.product.has(value) || isProductInCart(value) || isRemoveGift(value)) {
                  if (isRemoveGift(value)) {
                    //console.log("Producto eliminado manualmente, no se agregará nuevamente:", idItem);
                  } else {
                    //console.log(`Producto ya aplicado o en el carrito: ${value}`);
                  }
                } else {
                  // Agregar el producto al carrito y marcarlo como aplicado
                  productsAdd.push(value);
                  appliedRewards.product.add(value);
                }
                break;
              default:
                //console.log(`Tipo de recompensa no válido: ${type}`);
            }
          });
    
          if (Object.keys(couponsApplied).length > 0 && Object.keys(couponsAdd).length === 0) {
            const discountField = document.querySelectorAll('.discount-code-field');
            if (discountField.length > 0) {
              discountField.forEach(input => {
                input.value = couponsApplied.join(',');
              });
            }
          }
          if (Object.keys(couponsAdd).length > 0) {
            applyDiscountsReward(couponsAdd).then(response => {
              resolve(response);
            }).catch((error) => {
              console.error('Error:', error);
              reject(error);
            });
          } else if (Object.keys(productsAdd).length > 0) {
            addRewardProducts(productsAdd).then(response => {
              resolve(response);
            }).catch((error) => {
              console.error('Error:', error);
              reject(error);
            });
          } else {
            // no hubo cupones o productos a remover o agregar
            resolve();
          }
        }
      });
    };

    const deleteRewards = (removeRewards) => {
      return new Promise((resolve, reject) => {
        // Primero quitamos los rewards que no se deben agregar
        let couponsRemove = [], productsRemove = [];
        // concadenamos todos los cupones y productos que se deben remover
        removeRewards.forEach((reward) => {
          const { type, value } = reward;
          switch (type) {
            case 'coupon':
              // Verificar si el cupón ya está aplicado
              let isCouponApplied = validApplyedCoupon(value)
              isCouponApplied === true && couponsRemove.push(value);
              break;
            case 'product':
              productsRemove.push(value);
              appliedRewards.product.delete(value); // Eliminar el producto del registro
              break;
          }
        });
        if (Object.keys(couponsRemove).length > 0) {
          // si hay al menos cupon a remover se elimina los cupones en total y terminamos el proceso
          updateDiscountField('CLEAR').then(response => {
            resolve(response);
          }).catch((error) => {
            console.error('Error:', error);
            reject(error);
          });
        } else if (Object.keys(productsRemove).length > 0) {
          removeRewardProducts(productsRemove).then(response => {
            resolve(response);
          }).catch((error) => {
            console.error('Error:', error);
            reject(error);
          });
        } else {
          resolve();
        }
      });
    };
    
    const applyDiscountsReward = (couponsAdd) => {
      return new Promise((resolve, reject) => {
        if (Object.keys(couponsAdd).length > 0) {
          updateDiscountField(couponsAdd.join(','))
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              console.error('Error:', error);
              reject(error);
            });
        } else {
          // no hubo cupones o productos a remover o agregar
          resolve();
        }
      });
    };
    
    const removeRewardProductByKey = (cartKey, manual = false) => {
      // Buscar el producto en el carrito usando el cartKey
      const productExists = window.liquidAjaxCart.cart.items.find((item) => item.key === cartKey);
    
      if (productExists) {
        // Verificar si es un producto tipo regalo
        const isGift = productExists.properties && productExists.properties._ajax_cart_reward;
    
        if (!isGift) {
          //console.log(`Producto con cartKey ${cartKey} no es un regalo, no se eliminará.`);
          return;
        }
    
        // Registrar eliminación manual si corresponde
        if (manual) {
          addRemovedGift(productExists.variant_id, true);
        } else {
          clearRemovedGift(productExists.variant_id); // Eliminar del registro si no es manual
        }
    
        // Eliminar el producto del carrito
        window.liquidAjaxCart.change({
          id: cartKey,
          quantity: 0,
        }, {});
        //console.log(`Producto tipo regalo eliminado (manual: ${manual}): ${cartKey}`);
      }
    };

    /**
     * UTILS **/

    /*const disabledSmartCart = (event) => {
      const originalForms      = document.querySelectorAll('.original-product-form');
      const testForms          = document.querySelectorAll('.test-product-form');
      const cartToggleOriginal = document.querySelectorAll('[data-js-cart-icon]');
      const cartToggleTest     = document.querySelectorAll('[data-ajax-cart-icon=""]');
      const isTest             = document.body.getAttribute('data-change-cart');
    
      if (null != isTest) {
        
        if(window.Rebuy){
          window.Rebuy.SmartCart = window.Rebuy.SmartCart || {};
          window.Rebuy.SmartCart.status = 'disabled';
          console.info("SmartCart Rebuy disabled: ", window.Rebuy?.SmartCart.status);
        }

        originalForms.forEach(form => form.remove());
        //console.info("Forms ATC original remove");
        testForms.forEach(form => form.classList.remove('hidden'));
        cartToggleOriginal.forEach(el => el.remove());
        cartToggleTest.forEach(el => el.classList.remove('hidden'));
        
      } else {
        testForms.forEach(form => form.remove());
        cartToggleTest.forEach(el => el.remove());
      }
    };*/

    const validApplyedCoupon = (couponCode) => {
      const cartDiscount = window.liquidAjaxCart.cart.cart_level_discount_applications.find((item) => {
        let discount_application = item.discount_application;
        if (discount_application === undefined) {
          discount_application = item;
        }
        return discount_application?.title === couponCode;
      });
      if (cartDiscount === undefined) {
        return false;
      } else {
        return true;
      }
    };
    
    const updateDiscountField = (couponCode) => {
      return new Promise((resolve, reject) => {
        const discountField = document.querySelectorAll('.discount-code-field');
        if (discountField.length > 0) {
          if (couponCode === null) {
            couponCode = 'CLEAR';
          }
          discountField.forEach(input => {
            input.value = couponCode;
          });
          applyCoupon().then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
        } else {
          reject('No se encontró el campo de cupón');
        }
      });
    };

    const getCartSettings = () => {
      const json_element = document.getElementById('my-ajax-cart-json');
      const textContent = json_element.textContent.trim();
      return json_element && JSON.parse(textContent);
    };

    const buildCardUpsell = () => {
      return `<div class="swiper-slide relative max-w-full">
                <article id="my_ajax_cart__[ID_PROD]" class="my-ajax-cart-upsell--slider--card w-full bg-[#fff] border-[#DDDDDD] rounded-lg p-[16px] flex overflow-hidden gap-x-2">
                  <figure class="rounded-lg overflow-hidden w-[72px] h-[72px]">
                    <img
                      class="w-full h-full object-cover rounded-lg"
                      src="[IMG_SRC]"
                      alt="[TITLE_PROD]" />
                  </figure>
                  <div class="flex flex-grow flex-col gap-y-2">
                    <a class="font-bold text-[12px] leading-[18px]" href="[URL_PROD]">[TITLE_PROD]</a>
                    <button
                      class="w-[152px] h-[32px] rounded-full text-[#0F4FAC] border border-[#0F4FAC] font-bold border-solid py-[7.5px] px-[26px]"
                      type="button"
                      onclick="window.my_ajax_cart_atc(event)"
                      data-id="[ID_PROD]"
                      data-variant-id="[ID_VARIANT]">Add - [PRICE]</button>
                  </div>
                </article>
              </div>`;
    };

    const isProductInCart = (idItem) => {
      const productExists = window.liquidAjaxCart.cart.items.some((item) => {
        return item.id === parseInt(idItem);
      });
      return productExists;
    };

    const loadUpsellSwiper = (selectors) => {
      import(/* @vite-ignore */ flu.chunks.swiper).then(({ Swiper, Navigation }) => {
        const swiperOptions = {
          modules: [Navigation],
          slidesPerView: 1.3,
          spaceBetween: 8,
          navigation: {
            nextEl: selectors.navigationNext,
            prevEl: selectors.navigationPrev,
          },
        };
    
        new Swiper(selectors.element, swiperOptions);
      });
    };
    
    const loadUpsell = () => {
      const lineItems = window.liquidAjaxCart.cart.items;
      const slider = document.querySelector('.my-ajax-cart-upsell--slider');
      if (!slider) return;
      const connection = slider.dataset.connection;
    
      if (lineItems.length > 0) {
        if (connection == 'api') {
          const fetchPromises = [];
          const recommendedProd = new Set();
          lineItems.forEach((item) => {
            const promise = fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=4`)
              .then(response => response.json())
              .then((data) => data.products.forEach(prod => recommendedProd.add(JSON.stringify(prod))))
              .catch((error) => console.error("Error: ", error));
    
            fetchPromises.push(promise);
          });
    
          Promise.all(fetchPromises).then(() => {
            const uniqueProds = Array.from(recommendedProd).map((product) => JSON.parse(product));
            const container = document.querySelector('.my-ajax-cart-upsell--slider-container');
    
            const html = uniqueProds.map(prod => {
              //console.log("qwer",prod);
              let template = buildCardUpsell();
              template = template
                .replaceAll("[TITLE_PROD]", prod.title)
                .replaceAll("[ID_PROD]", prod.id)
                .replaceAll("[IMG_SRC]", prod.featured_image)
                .replaceAll("[URL_PROD]", prod.url)
                .replaceAll("[ID_VARIANT]", prod.variants[0].id)
                .replaceAll("[PRICE]", (prod.price / 100));
    
              return template;
            }).join('');
    
            container.innerHTML = html;
            loadUpsellSwiper({ element: '.my-ajax-cart-upsell--slider', navigationNext: '.my-cart__upsell--arrow-right', navigationPrev: '.my-cart__upsell--arrow-left' });
          });
    
        } else {
          loadUpsellSwiper({ element: '.my-ajax-cart-upsell--slider', navigationNext: '.my-cart__upsell--arrow-right', navigationPrev: '.my-cart__upsell--arrow-left' });
        }
      }
    };

    const fixExpressButtons = () => {
      const parent = document.querySelector('.my-cart shopify-accelerated-checkout-cart');
      if (!parent) {
        return;
      }

      let left = `144px`; 
      const media = window.matchMedia("(max-width: 768px)").matches;
      
      if (parent.children.length === 2) {
        const [first, second] = parent.children;
        const secondDisplay = second?.computedStyleMap().get('display').value;

        if (second && secondDisplay == 'none') {
          if(media){
            left = `125px`;
          }
          first.style.left = left;
          parent.style.transform = 'none';
          parent.style.margin = 'inherit';
        }
      } else if ( parent.children.length === 3 ){
        const [first, second, third] = parent.children;
        
        const secondDisplay = second?.computedStyleMap().get('display').value;
        const thirdDisplay = third?.computedStyleMap().get('display').value;
        
        
        if (secondDisplay == 'none' && thirdDisplay == 'none') {
          if(media){
            left = `105px`;
          }
          
          first.style.left = left;
          parent.style.transform = 'none';
          parent.style.margin = 'inherit';
        }
      }

      parent.classList.add(`items-${parent.children.length}`);
    };

    /**
     * INITIALIZE **/
    const appliedRewards = {
      discount: null, // Último cupón aplicado
      product: new Set(), // Productos de recompensa aplicados
    };
    
    const onInitAjaxCart = () => {
      window.Rebuy?.SmartCart?.init({ enabled: true, openOnAdd: true });
      loadUpsell();
      fixExpressButtons();
      updateSidecart();
    };

    const ifActiveGamification = () => {
      return document.querySelector('.contenedor-gamification') ? true : false;
    };

    const validateGamification = () => {
      const items = window.liquidAjaxCart.cart?.items || [];
      const gifts = items.filter(item => item.properties && item.properties._ajax_cart_reward);
      const updates = {};

      gifts.forEach(gift => {
        updates[gift.key] = 0;
      });

      if (Object.keys(updates).length > 0) {
        window.liquidAjaxCart.update({
          updates
        }, {
          lastCallback: () => {
            const key = "removeGiftProducts";
            sessionStorage.removeItem(key);
          }
        });
      }
    };

    const updateSidecart = () => {
      window.liquidAjaxCart.update({});
    }

    const onCartUpdate = () => {
      //console.log("Cart updated");
      loadUpsell();
      fixExpressButtons();
      if (ifActiveGamification()) {
        validateGamification();
      }
      updateSidecart();
    };

    const onDocumentLoad = () => {
      
      window.my_ajax_cart_atc = (event) => {
        const { target : { dataset: { variantId } } } = event;
        window.liquidAjaxCart.add({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        }, {});
      };

      window.my_ajax_cart_remove = function(event, cartKey) {
        event.preventDefault();
        // Lógica de eliminación manual
        removeRewardProductByKey(cartKey, true); // true indica eliminación manual
      };            
    
      liquidAjaxCart.conf('updateOnWindowFocus', false);
      liquidAjaxCart.conf('quantityTagAllowZero', true);
    
      const btnToggleCart = document.querySelectorAll('[data-ajax-cart-icon=""]');
    
      btnToggleCart.forEach(btn => btn.addEventListener('click', openAjaxCart));
      
      if ( ifActiveGamification() ) {
        updateGamification();
        validateGamification();
      }
    };

    setTimeout(() => {
      onDocumentLoad();
    }, 500);

    if (window.liquidAjaxCart?.init) {
      onInitAjaxCart();
    } else {
      document.addEventListener('liquid-ajax-cart:init', onInitAjaxCart);
    }

    /**
     * LISTENER **/
    document.addEventListener('liquid-ajax-cart:request-end', onChangeAjaxCart);
    
    /*document.addEventListener('rebuy:smartcart.ready', ()=> {
      setTimeout(() => {
        disabledSmartCart();//This should be to remove when deactive the smart cart from dashboar rebuy
      }, 500);
    });*/

    
  }
});